import { useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import api from "../../api/axios";
import { authReturnTo, rememberReturnTo } from "../../utils/authReturnTo";

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const requestedReturnTo = searchParams.get("returnTo");
  const returnTo = authReturnTo(requestedReturnTo);
  const [status, setStatus] = useState(token ? "verifying" : "pending");
  const [message, setMessage] = useState(token ? "Estamos verificando tu email..." : "Te enviamos un enlace de verificacion.");
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.post("/auth/verify-email", { token })
      .then(({ data }) => {
        if (data.token) localStorage.setItem("token", data.token);
        if (data.user) localStorage.setItem("user", JSON.stringify(data.user));
        rememberReturnTo(returnTo);
        setStatus("verified");
        setMessage("Email verificado. Tu cuenta ya puede usar todas las funciones de Cardora.");
      })
      .catch(error => {
        setStatus("error");
        setMessage(error?.response?.data?.error || "El enlace no es valido o ha caducado.");
      });
  }, [token, returnTo]);

  const resend = async () => {
    setResending(true);
    try {
      const { data } = await api.post("/auth/resend-verification", { returnTo });
      setMessage(data.alreadyVerified
        ? "Tu email ya estaba verificado."
        : data.throttled
          ? "Ya enviamos un correo recientemente. Revisa tambien spam."
          : "Enviamos un nuevo enlace. Revisa tu bandeja y spam.");
      if (data.alreadyVerified) setStatus("verified");
    } catch {
      setMessage("No pudimos reenviar el correo en este momento.");
      setStatus("error");
    } finally {
      setResending(false);
    }
  };

  return (
    <Container className="page-band">
      <Row className="justify-content-center">
        <Col md={7} lg={5}>
          <Card className="cardora-card">
            <Card.Body className="text-center">
              {status === "verifying" && <Spinner animation="border" className="mb-3" />}
              <h1 className="section-title mb-2">{status === "verified" ? "Email verificado" : "Verifica tu email"}</h1>
              <Alert variant={status === "error" ? "danger" : status === "verified" ? "success" : "info"}>{message}</Alert>
              <div className="d-grid gap-2">
                {status !== "verified" && localStorage.getItem("token") && (
                  <Button className="btn-cardora" disabled={resending} onClick={resend}>
                    {resending ? "Enviando..." : "Reenviar enlace"}
                  </Button>
                )}
                <Button as={Link} to={returnTo} variant="outline-dark">
                  {returnTo.includes("card=") ? "Volver a la carta" : "Continuar en Cardora"}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default VerifyEmail;
